import { render, staticRenderFns } from "./A10.vue?vue&type=template&id=605d5057"
import script from "./A10.vue?vue&type=script&lang=js"
export * from "./A10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports